import { SORT, TYPES } from '../utils/constants';
import { getHeaderTextByProp, removeCurrencyFormatter } from '../utils/helpers';
import styles from './OptionPanel.module.scss';
import sortAsc from 'assets/images/sort-asc.svg';
import sortDesc from 'assets/images/sort-desc.svg';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const OptionPanel = ({
    style,
    header,
    updateSortFilters,
    clearFilter,
    closePanel
}) => {
    const [searchText, setSearchText] = useState('');
    const [sortOrder, setSortOrder] = useState();

    useEffect(() => {
        const { filterData, sortData } = header;

        if (filterData || sortData) {
            setSearchText(filterData ? filterData.filterValue : '');
            setSortOrder(sortData ? sortData.sortDirection : null);
        } else {
            resetState();
        }
    }, [header]);

    const resetState = () => {
        setSortOrder();
        setSearchText('');
    };

    const onSortingClick = (sorting) => {
        const columnName = getHeaderTextByProp(header.prop);
        setSortOrder(sorting);

        const sort = {
            sortDirection: sorting,
            columnName
        };

        updateSortFilters(sort, null);
    };

    const onApplyClick = () => {
        const columnName = getHeaderTextByProp(header.prop);
        let sort;
        let filter;
        let filterValue;

        if (sortOrder) {
            sort = {
                sortDirection: sortOrder,
                columnName
            };
        }

        if (header.type === TYPES.num && header.subType === TYPES.currency) {
            filterValue = removeCurrencyFormatter(searchText);
        } else if (header.type === TYPES.num) {
            filterValue = parseFloat(searchText, 10);
        } else {
            filterValue = (searchText || '').trim();
        }

        filter = {
            columnName,
            filterValue,
            filterDataType: header.type
        };

        updateSortFilters(sort, filter);
    };

    const onClearClick = () => {
        const columnName = getHeaderTextByProp(header.prop);
        setSearchText('');
        clearFilter(columnName);
    };

    return (
        <>
            <div
                onClick={closePanel}
                className={styles.controlPanelBackground}
            />
            <div className={styles.controlPanel} style={style}>
                <div className={styles.topSection}>
                    <div
                        className={`${styles.sortAsc} ${
                            sortOrder === SORT.asc ? styles.selected : ''
                        }`}
                        onClick={() => onSortingClick(SORT.asc)}
                    >
                        <img src={sortAsc} alt="" />
                        <span>Sort Smallest to Largest</span>
                    </div>
                    <div
                        className={`${styles.sortDesc} ${
                            sortOrder === SORT.desc ? styles.selected : ''
                        }`}
                        onClick={() => onSortingClick(SORT.desc)}
                    >
                        <img src={sortDesc} alt="" />
                        <span>Sort Largest to Smallest</span>
                    </div>
                </div>
                <div className={styles.bottomSection}>
                    <div className={styles.search}>
                        <input
                            placeholder="Search"
                            type={header.type === TYPES.num ? 'number' : 'text'}
                            name="search"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className={searchText.length ? styles.hasText : ''}
                        />
                    </div>
                    <div className={styles.btns}>
                        <button
                            className={`${styles.apply} ${
                                searchText.length > 0 ? styles.hasText : ''
                            }`}
                            onClick={onApplyClick}
                        >
                            Apply Search
                        </button>
                        <button className={styles.clear} onClick={onClearClick}>
                            Clear Search
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

OptionPanel.propTypes = {
    style: PropTypes.shape({}),
    header: PropTypes.shape({
        filterData: PropTypes.shape(),
        sortData: PropTypes.shape({
            columnName: PropTypes.string,
            sortDirection: PropTypes.string,
            sortPriority: PropTypes.number
        }),
        prop: PropTypes.string,
        type: PropTypes.string,
        subType: PropTypes.string
    }),
    updateSortFilters: PropTypes.func,
    clearFilter: PropTypes.func,
    closePanel: PropTypes.func
};
export default OptionPanel;
